import { getEnvironment } from './getEnvironment';

export function getPricingUrl(): string {
  if (getEnvironment() === 'production') {
    return 'https://docs.cutwise.com/pricing';
  }

  return 'https://docs-staging.cutwise.com/pricing';
}
